import { ref, shallowRef } from '@vue/composition-api'

// 顶部通知 + 滚动广播，目前仅用在首页
export default function useLayoutNotice() {
  // 重要通知
  const noticeMessage = ref('')
  // 滚动广播
  const broadcastList = shallowRef([])

  // 设置通知 & 广播
  const setNotice = (data) => {
    if (data && data.length) {
      const res = {}
      data.forEach((x) => {
        if (x.groupType === 1) {
          // 1 重要通知
          const noticeList = x && x.infos
          const notice = noticeList && noticeList[0]
          noticeMessage.value = notice ? notice.text : ''
        } else if (x.groupType === 2) {
          // 2 滚动广播
          const broadcast = x && x.infos
          broadcastList.value = broadcast || []
        }
      })
      return res
    }
  }

  return {
    noticeMessage,
    broadcastList,
    setNotice
  }
}
